import { Language } from '@/interfaces'

export const en: Language = {
  about: 'About',
  account: 'Account',
  action: 'Action',
  aboutPage: 'This is an about page',
  amountExceedsAvailableInventoryOf:
    'Please enter an amount that does not exceed available quantity of',
  approve: 'Approve',
  approvedBy: 'Approved by',
  arriving: 'Arriving',
  available: 'Available',
  availableQuantity: 'Available Qty',
  availableToPull: 'available to pull',
  available30days: 'Inventory Exceeding 30 days',
  back: 'back',
  billToParty: 'Bill-to party',
  buyer: 'Buyer',
  byProduct: 'by Product',
  calendarDay: 'Calender Day',
  calendarWeek: 'Calendar Week',
  cancel: 'Cancel',
  canceled: 'Canceled',
  canceledBy: 'Canceled by',
  canceledDate: 'Cancelled Date',
  cancelPrompt: 'Are you sure?',
  cancelDetails: 'You will lose any data you have entered on this page.',
  cancelConfirm: 'Confirm cancel',
  cancelDimiss: 'Stay here',
  carrierTracking: 'Carrier Tracking',
  chooseAccountInstructions: 'Please choose an account from the dropdown to begin',
  ChooseAPart: 'Choose a part',
  contactBuyer: 'Contact Buyer',
  contactCSO: 'Contact CSO',
  continue: 'Continue',
  cpn: 'CPN',
  customerPart: 'Customer part',
  customerPO: 'Customer PO',
  customerUploadedPo: '*Customer uploaded PO',
  dashboard: 'Dashboard',
  deleteConfirm: 'Confirm delete',
  deleteConfirmMessage: 'Are you sure you want to delete these {count} messages?',
  deleteSelectedMessages: 'Delete selected messages',
  delivery: 'Delivery',
  deliveredOn: 'Delivered On',
  deny: 'Deny',
  designID: 'Design ID',
  documentation: 'documentation',
  ecosystem: 'Ecosystem',
  edit: 'Edit',
  enterAPONumber: 'Enter a PO number',
  enterAReferenceNumber: 'Enter a reference number',
  enterPoOrReferenceNumber: 'Enter a PO or Reference Number',
  endCustomer: 'End Customer',
  error: 'Error',
  errorLoadingData: 'Error loading data',
  errorProcessingPR: 'There was an error processing pull request #: {salesOrderNumber}',
  errorProcessingRequest: 'Error processing request',
  essentialLinks: 'Essential Links',
  expectedShipDate: 'Expected Ship Date',
  expectedShipDateWrapped: 'Expected<br/> Ship Date',
  exportFullReport: 'Export Full Report',
  exportAll: 'Export All',
  filterAddresses: 'Filter Addresses',
  getReport: 'Get Report',
  greeting: 'Welcome to Your Vue.js + TypeScript App',
  home: 'Home',
  hi: 'Hi',
  history: 'History',
  iAmNotIndicatingAPOAtThisTime: 'I am not indicating a PO at this time',
  incoterms: 'Incoterms',
  indicateAPOUsingAnOptionBelow: 'Indicate a PO using an option below',
  inLastSevenDays: 'in last 7 days',
  inProgress: 'in progress',
  instructions:
    'For a guide and recipes on how to configure / customize this project, check out the',
  installedPlugins: 'Installed CLI Plugins',
  inTransit: 'in transit',
  inventory: 'Inventory',
  last30Days: 'Last 30 Days',
  link: 'Link',
  login: 'Login',
  logout: 'Log out',
  messages: 'Messages',
  micronEntity: 'Micron Entity',
  micronPart: 'Micron part',
  mpn: 'MPN',
  next: 'Next',
  next10ReplenishmentsIntoVHub: 'next 10 replenishments into vhub',
  next30Days: 'Next 30 Days',
  noAttachment: 'No attachment found',
  noMicronEntity: 'No {field} data exists for this Micron Entity.',
  noNewMessages: 'There are no messages.',
  noParts: 'There is no inventory to show.',
  noPO: 'No PO specified',
  noPulls: 'There are no pulls to show.',
  noReplenishments: 'There are no replenishments to show.',
  noReports: 'No report found',
  noShipments: 'There are no shipments to show.',
  notAvailable: 'N/A',
  noteAttachmentIssue:
    'NOTE: If you encounter issues opening this attachment, please review the attachment in SAP.',
  notifications: 'Notifications',
  ok: 'OK',
  pleaseEnterAnAmountThatIsAMultipleOfTheSBQ:
    'Please enter an amount that is a multiple of the Standard Box Quantity',
  part: 'Part',
  pending: 'Pending',
  pendingReview: 'pending review',
  physicalHubInventory: 'Physical Hub Inventory',
  poAttachedFileTypes:
    'The attached file must be one of the following:<br/>.doc, .xls, .pdf, .txt (preferred)<br/>.docx, .xlsx (also supported)',
  poReferenceNumber: 'PO Reference Number',
  previewPull: 'Preview pull',
  processing: 'Processing',
  productFamily: 'Product Family',
  productGroup: 'Product Group',
  pullDate: 'Pull Date',
  pullID: 'Pull ID',
  pullInventory: 'Pull Inventory',
  pullPending: 'Pull Pending',
  pullQuantity: 'Pull quantity',
  pullQuantityInfo:
    'Enter quantity in multiples of {SBQ}, up to the available quantity of {availableQty}.',
  pullQuantityInfoCSO:
    'It is recommended to enter quantity in multiples of {SBQ}, up to the available quantity of {availableQty}.',
  pullRequests: 'Pull Requests',
  pulls: 'Pulls',
  pullRequested: 'Pull Requested',
  pullRequestDenied: 'Pull Request #{salesOrderNumber} has been denied.',
  pullRequestProcessed: 'Pull Request #{salesOrderNumber} has been successfully processed.',
  pullRequestSubmittedCSO: 'Success. Your pull has been successfully submitted.',
  pullRequestSubmittedForReview: 'Your pull request has been submitted for review.',
  pullRequestSubmittedWithUploadError:
    'Your pull request has been successfully submitted, however there was an error saving your attachment. Please contact your CSO with the PO you attached to your pull request.',
  pullRequestSubmittedError: 'There was an error submitting your pull request.',
  pullRequestSubmittedErrorCSO: 'There was an error submitting your pull.',
  pullRequestUpdatedError: 'There was an error saving this pull request.',
  pullToCustomerInventory: 'Pull to Customer Inventory',
  pullToCustomerOwnedInventory: 'Pull to Customer Owned Inventory',
  pullToPhysicalHub: 'Pull to Physical Hub',
  pullType: 'Pull type',
  pullWarningMessage: 'This order is missing a CQ record and has no PO attachment.',
  purchaseOrder: 'Purchase Order',
  purchaseOrderNum: 'PO #',
  poNumber: 'PO number',
  quantity: 'Quantity',
  reason: 'Reason',
  refreshTime: 'Refresh Time',
  removeSelectedAlerts: 'Remove selected alerts',
  replenishments: 'Replenishments',
  replenishmentsIntoVHub: 'Replenishments into vHub',
  requestedBy: 'Requested by',
  requestedQuantity: 'Requested Qty',
  requestedQuantityWrapped: 'Requested<br/> Qty',
  requestedShipDate: 'Requested Ship Date',
  review: 'Review',
  salesOrder: 'Sales Order',
  salesOrderNum: 'SO #',
  scheduledThisWeek: 'scheduled this week',
  selectACurrentPO: 'Select a current PO',
  selectFile: 'Select File',
  share: 'Share',
  selectAReason: 'Select a reason',
  sendUsAMessage: 'Send us a message below',
  sendUsAMessageSuccess: 'Message succefully sent',
  shipDate: 'Ship Date',
  shipTo: 'Ship to',
  shipFrom: 'Plant',
  shipToCity: 'Ship to City',
  shipmentDetails: 'Shipment details',
  shipmentPending: 'Shipment Pending',
  shipments: 'Shipments',
  shipmentsFromVHub: 'Shipments from vHub',
  shipmentsHistorical: 'Shipments History',
  shipped: 'Shipped',
  soldTo: 'Sold to',
  standardBoxQuantity: 'Standard Box Quantity',
  status: 'Status',
  subject: 'Subject',
  submit: 'Submit',
  success: 'Success',
  subTechnology: 'Sub-technology',
  to: 'To',
  total: 'Total',
  totalVHub: 'Total vHub',
  totalInventory: 'Total Inventory',
  totalVHubInventory: 'Total vHub Inventory',
  trackShipment: 'Track Shipment',
  trackShipmentAttr: 'Commercial Invoice',
  trackShipmentAttrPack: 'Packing List',
  unitQuantity: 'Unit Quantity',
  uploadANewPO: 'Upload a new PO',
  vhubInventory: 'vHub Inventory',
  viewAll: 'View all',
  viewMore: 'View more',
  viewShippingInfo: 'View shipping info',
  viewPullRequest: 'View pull request',
  writeHere: 'Write here...',
  search: 'Search..',
}
